<template>
  <div>
    <div v-if="!shouldShouldAssets">
      <div class="text-5 font-weight-medium">Staking Asset</div>
      <div class="d-flex align-center mt-2" v-if="selectedAsset">
        <img
          :src="
            ($vuetify.theme.dark
              ? selectedAsset.logoSmallDark
              : selectedAsset.logoSmall) || selectedAsset.logoSmall
          "
          height="34"
          width="34"
          :alt="selectedAsset.name"
        />
        <div class="ml-4">
          <div class="heading-5 font-weight-medium text-uppercase">
            {{ selectedAsset.staking.token }}
          </div>
          <div class="text-6 font-weight-light gray--text mt-1">
            {{ selectedAsset.text }}
          </div>
        </div>
        <v-icon
          v-if="assets.length > 1"
          class="align-self-start black--text"
          @click="shouldShouldAssets = true"
          >mdi-chevron-down</v-icon
        >
      </div>
    </div>
    <div v-else class="asset-list d-flex flex-column">
      <div>
        <v-text-field
          v-model="search"
          placeholder="Search assets"
          prepend-inner-icon="mdi-magnify"
          type="text"
          outlined
          class="c-input search-stake"
          hide-details
          autofocus
        ></v-text-field>
      </div>
      <div class="d-flex align-center justify-space-between mt-10">
        <div class="text-5 font-weight-medium">Staking Asset</div>
        <div class="text-5 font-weight-medium">APY</div>
      </div>
      <div class="flex-1 overflow-auto mt-4">
        <div
          class="d-flex align-center justify-space-between mt-5 clickable"
          v-for="asset in assets"
          :key="asset.name"
          @click="setAsset(asset)"
        >
          <div class="d-flex align-center">
            <img
              :src="
                ($vuetify.theme.dark ? asset.logoSmallDark : asset.logoSmall) ||
                  asset.logoSmall
              "
              height="34"
              width="34"
              :alt="asset.name"
            />
            <div class="ml-4">
              <div class="heading-5 font-weight-medium text-uppercase">
                {{ asset.staking.token }}
              </div>
              <div class="text-6 font-weight-light gray--text mt-1">
                {{ asset.text }}
              </div>
            </div>
          </div>
          <div class="heading-5 font-weight-medium text-right">
            {{ asset.apy | numberFormat("0,0.00", false) }} %
          </div>
        </div>
      </div>
      <div class="mt-10">
        <c-btn class="width-100" is-default @click="shouldShouldAssets = false"
          >Cancel</c-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      getTokenPrice: "appConfig/getTokenPriceInUsd",
      stakeApyMap: "productStats/stakeApyMap",
      activeProjects: "projectConfig/activeProjects",
    }),
    assets() {
      return this.activeProjects
        .filter(pr => pr.ecosystem === this.ecosystem)
        .filter(
          pr =>
            !this.search ||
            pr.name.toLowerCase().includes(this.search.toLowerCase())
        )
        .map(pr => ({
          ...pr,
          apy: this.stakeApyMap[pr.name]?.apy * 100,
        }));
    },
  },
  props: ["ecosystem", "selectedAsset"],
  data: () => ({
    search: "",
    shouldShouldAssets: false,
  }),
  methods: {
    setAsset(asset) {
      this.shouldShouldAssets = false;
      if (asset.projectName === this.$route.params.projectName) return;
      if (this.ecosystem === "Tendermint") {
        return this.$router.replace({
          name: this.$route.name,
          query: this.$route.query,
          params: {
            projectName: asset.projectName,
          },
        });
      }
      return this.$router.replace({
        path: `/stake/${asset.name}`,
        query: this.$route.query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.asset-list {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: var(--main-bg);
}
</style>
